import { render, staticRenderFns } from "./markSetting.vue?vue&type=template&id=3d8ae312"
import script from "./markSetting.vue?vue&type=script&lang=js"
export * from "./markSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports